/* eslint-disable react/no-unknown-property */
import React from 'react'

import Marker from '../objects/marker'

import { MarkerInterface } from './types'

function LevelMarker({
  position,
  title,
  subTitle,
  svg,
  visible,
  mainStyleOverride,
  svgStyleOverried,
  titleStyleOverried,
  subTitleStyleOverried
}: MarkerInterface) {
  return (
    <group position={position} key={title}>
      <Marker maxScale={0.9} minScale={0.4} visible={visible}>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
            padding: '6px 14px 6px 6px',
            borderRadius: 999,
            background: 'rgba(18, 18, 20, 0.86)',
            border: '1px solid rgba(255, 255, 255, 0.14)',
            boxShadow: '0 6px 18px rgba(0, 0, 0, 0.35)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            fontFamily:
              "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
            color: '#ffffff',
            whiteSpace: 'nowrap',
            userSelect: 'none',
            cursor: 'pointer',
            ...mainStyleOverride,
          }}
        >
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: '50%',
              background: '#ffffff',
              boxShadow: 'inset 0 0 0 1px rgba(0, 0, 0, 0.08)',
              flexShrink: 0,
              ...svgStyleOverried,
            }}
          >
            {svg}
          </span>
          <span
            style={{
              display: 'flex',
              flexDirection: 'column',
              lineHeight: 1.2,
            }}
          >
            <span style={{ fontSize: 17, fontWeight: 600, letterSpacing: 0.2, 
              ...titleStyleOverried
            }}>
              {title}
            </span>
            <span
              style={{
                fontSize: 12,
                fontWeight: 400,
                color: 'rgba(255, 255, 255, 0.7)',
                ...subTitleStyleOverried
              }}
            >
              {subTitle}
            </span>
          </span>
        </div>
      </Marker>
    </group>
  )
}

export default LevelMarker
